import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/octicons/octicons/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><a parentName="p" {...{
        "href": "https://rubygems.org/gems/jekyll-octicons"
      }}><img parentName="a" {...{
          "src": "https://img.shields.io/gem/v/jekyll-octicons.svg",
          "alt": "Gem version"
        }}></img></a></p>
    <p>{`The Jekyll liquid tag is a plugin that lets you include octicons in your Jekyll sites.`}</p>
    <h2>{`Install`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Add this to your `}<inlineCode parentName="p">{`Gemfile`}</inlineCode></p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-rb"
          }}>{`gem 'jekyll-octicons'
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Add this to your jekyll `}<inlineCode parentName="p">{`_config.yml`}</inlineCode></p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-yml"
          }}>{`plugins:
  - jekyll-octicons
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Use this tag in your jekyll templates`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`{% octicon alert height:32 class:"right left" aria-label:hi %}
`}</code></pre>
      </li>
    </ol>
    <p>{`We recommend including the CSS in the `}<a parentName="p" {...{
        "href": "/packages/javascript"
      }}><inlineCode parentName="a">{`@primer/octicons`}</inlineCode></a>{` npm module. You can also npm install that package and include `}<inlineCode parentName="p">{`build/build.css`}</inlineCode>{` in your styles.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      